export const careStatusOptions = [
  { text: '待發送', value: '0' },
  { text: '已發送', value: '1' },
  { text: '待重試', value: '2' },
  { text: '取消發送', value: '3' },
  { text: '處理中', value: '4' },
  { text: '時間已過', value: '5' },
];

export function careStatusLabel(status) {
  const option = careStatusOptions.find(item => item.value === String(status));
  return option ? option.text : '未知';
}

export function careStatusColor(status) {
  return ['blue-6', 'green-6', 'red-6', 'grey-5', 'orange-6', 'red-6'][Number(status)] || 'grey-5';
}

export function canResendCareMessage(message) {
  return message.can_resend === true && ['1', '2', '3', '5'].includes(String(message.send_status));
}

export function canCancelCareMessage(status) {
  return ['0', '2', '4', '5'].includes(String(status));
}

export function careEditStatusOptions(message) {
  const allowed = message.originalStatus === '0' ? ['0', '3'] : ['3'];
  return careStatusOptions.filter(option => allowed.includes(option.value) || option.value === message.originalStatus);
}

export function careEditTimeDisabled(message, saving = false) {
  return saving || Boolean(message.resendResult) || message.batchSubmitted
    || Boolean(message.resendIntent && message.resendIntent.uncertain)
    || (message.operation !== 'resend' && (message.originalStatus !== '0' || message.status === '3'));
}

export function careResendBlockMessage(reason) {
  if (!reason) return '';
  const messages = {
    FORBIDDEN: '目前無權限重新安排此訊息。',
    USE_PENDING_EDITOR: '待發送訊息請直接編輯原排程。',
    SEND_IN_PROGRESS: '訊息正在處理中，目前僅可取消。',
    RESERVE_UNAVAILABLE: '約診目前無法發送訊息。',
    ITEM_UNAVAILABLE: '訊息項目已移除，無法重新安排。',
    CARE_LINK_REMOVED: '訊息與約診的關聯已移除，無法重新安排。',
    SMART_TAG_REMOVED: '智能個管師標籤已移除，無法重新安排。',
    RECIPIENT_CHANGED: '收件對象或發送帳號已變更，請重新確認。',
    CONTENT_UNAVAILABLE: '原訊息內容無法使用，無法重新安排。',
    SOURCE_UNAVAILABLE: '原排程目前無法使用，請重新整理確認。',
    INVALID_MANUAL_MARKERS: '排程資料不完整，請重新整理確認。',
  };
  return messages[reason] || '目前無法重新安排，請重新整理確認。';
}
